import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { AuthActions, AuthSelectors } from '../../../features/Auth';
import { BasketActions } from '../../../redux/basket';
import * as BasketSelectors from '../../../redux/basket/selectors';

export function useEnsureCitysprintBasket() {
  const dispatch = useDispatch();
  const store = useStore();
  const currentSession = useSelector(AuthSelectors.getCurrentSession);
  const authIsLoading = useSelector(AuthSelectors.getIsLoading);

  useEffect(() => {
    if (authIsLoading) {
      return undefined;
    }
    if (currentSession?.basketId) {
      return undefined;
    }

    let cancelled = false;
    (async () => {
      try {
        const existingBasketId = BasketSelectors.getBasketId(store.getState());
        if (!existingBasketId) {
          await dispatch(BasketActions.createBasket()).unwrap();
        }
        if (cancelled) {
          return;
        }
        await dispatch(AuthActions.getCurrentSession()).unwrap();
      } catch {
        // Leave checkout / other flows to surface errors.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [authIsLoading, currentSession?.basketId, dispatch, store]);
}
